import React from "react";
import styled from "styled-components";
import { COLORS } from "../../../Constants/colors";
import whyChoose from "../../../Assets/why-choose.jpg";
import SectionWrapper from "../UI/SectionWrapper";

const Section = styled.section`
  display: flex;
  width: 100%;
  height: auto;
  overflow: hidden;
  background-color: ${COLORS?.backgroundLight};
  border-radius: 16px;

  @media (max-width: 1250px) {
    flex-direction: column-reverse;
  }
`;

const Content = styled.div`
  flex: 5.5;
  padding: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${COLORS.cardBackground};
  color: ${COLORS?.textPrimary};

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`;

const Image = styled.div`
  flex: 4.5;
  position: relative;
  overflow: hidden;
  border-radius: 0 16px 16px 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media (max-width: 1024px) {
    border-radius: 16px 16px 0 0;
  }
`;

const FeatureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.8rem;
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`;

const Icon = styled.div`
  font-size: 1.5rem;
  line-height: 1.2;
  color: ${COLORS?.primary};
`;

const TextContent = styled.div`
  h4 {
    margin: 0;
    font-size: 1.4rem;
    color: ${COLORS?.primary};
  }

  p {
    margin: 0.3rem 0 0;
    font-size: 1.3rem;
    line-height: 1.6;
    color: ${COLORS?.textPrimary};
  }
`;

const WhyChooseVirtuosoft = () => {
  return (
    <SectionWrapper heading="WHY CHOOSE VIRTUOSOFT?">
      <Section>
        <Content>
          <FeatureList>
            <FeatureItem>
              <Icon>✅</Icon>
              <TextContent>
                <h4>Proven Expertise Across Multiple Domains</h4>
                <p>Successfully delivering projects ranging from small to enterprise level.</p>
              </TextContent>
            </FeatureItem>

            <FeatureItem>
              <Icon>🌐</Icon>
              <TextContent>
                <h4>Global Clientele (Across the Globe and Timezone)</h4>
                {/* <p>Providing solutions for clients both in India and internationally.</p> */}
                <p>Able to provide services and solutions for global clients across different timezones 24X7 to ensure business continuity.</p>
              </TextContent>
            </FeatureItem>

            <FeatureItem>
              <Icon>💻</Icon>
              <TextContent>
                <h4>Technical Proficiency</h4>
                <p>Skilled team specializing in .Net, Angular, Node.js, React.js, MS SQL Server, Postgres SQL, MongoDB, MS Azure, AWS, Microservices architecture, Kubernetes, Message Queue, Redis and Elastic Search.</p>
              </TextContent>
            </FeatureItem>

            {/* <FeatureItem>
              <Icon>🛠️</Icon>
              <TextContent>
                <h4>Post-Warranty Support</h4>
                <p>Offering 2 months of free support for major issues.</p>
              </TextContent>
            </FeatureItem> */}

            <FeatureItem>
              <Icon>🧑‍💼</Icon>
              <TextContent>
                <h4>Flexible Resource Model</h4>
                <p>End-to-end delivery, staffing and task-based resourcing — tailored to business needs.</p>
              </TextContent>
            </FeatureItem>

            <FeatureItem>
              <Icon>📍</Icon>
              <TextContent>
                <h4>Prime Location</h4>
                <p>Based in Technopark, Trivandrum — India's largest IT park in a serene environment.</p>
              </TextContent>
            </FeatureItem>
          </FeatureList>
        </Content>
        <Image>
          <img src={whyChoose} alt="Why Choose Virtuosoft"/>
        </Image>
      </Section>
    </SectionWrapper>
  );
};

export default WhyChooseVirtuosoft;
